module.exports = __webpack_public_path__ + "static/media/background-default.8bd9ec48.jpg";